interface PersonWithArrowsSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PersonWithArrowsSVG = ({ color, style }: PersonWithArrowsSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="47"
    height="50"
    viewBox="0 0 47 50"
    fill="none"
  >
    <g clipPath="url(#clip0_947_6496)">
      <path
        d="M9.70377 37.4302C9.2744 37.7308 8.88797 38.0099 8.56594 38.2675C8.00776 38.7183 7.53546 39.2658 7.15976 39.8669C6.4513 40.994 6.12927 42.3143 6.12927 43.6453V49.4633H39.9313V43.6453C39.9313 42.3143 39.5986 40.994 38.9009 39.8669C38.5252 39.255 38.0528 38.7183 37.4947 38.2675C37.1726 38.0099 36.7862 37.7308 36.3568 37.4302"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.5264 25.7192C31.5264 31.5586 27.7158 36.2817 23.0142 36.2817C18.3126 36.2817 14.502 31.5479 14.502 25.7192C14.502 19.8905 18.3126 15.1567 23.0142 15.1567C27.7158 15.1567 31.5264 19.8905 31.5264 25.7192Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0249 12.3336V3.93946"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8351 3.04852L23.0249 0.848003L25.2146 3.02705"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.4642 30.2168L3.6604 33.3083"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.63887 35.6806L0.783569 34.4461L2.00727 31.6123"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M34.5857 30.2168L42.3787 33.3083"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.4001 35.6806L45.2554 34.4461L44.0425 31.6123"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_947_6496">
        <rect width="46.0498" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default PersonWithArrowsSVG;
